import { Box, styled, Typography } from '@mui/material';

export const InfoSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(3),
  backgroundColor: theme.palette.main.white,
  borderRadius: 6,

  '& + &': { marginTop: theme.spacing(2) },
}));

export const InfoSectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  lineHeight: '24px',
  fontWeight: 500,
  color: theme.palette.text.primary,
}));

export const InfoFacts = styled('dl')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  margin: 0,
}));

export const InfoFactRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

export const InfoFactLabel = styled('dt')(({ theme }) => ({
  fontSize: 14,
  lineHeight: '20px',
  color: theme.palette.main.grey600,
}));

export const InfoFactValue = styled('dd')(({ theme }) => ({
  margin: 0,
  fontSize: 14,
  lineHeight: '20px',
  color: theme.palette.text.primary,
  whiteSpace: 'pre-wrap',
  overflowWrap: 'anywhere',
}));

export const InfoText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  lineHeight: '20px',
  color: theme.palette.text.primary,
}));
